import React from 'react';

const SecondPage = () => {
    return (
        <section className='contain-second-page'>
            <h1>Why Sponsor HackMerced?</h1>
            <div className='second-page-text-line'>
                <div className='second-page-text-box1'>
                    <h2>Become the face of tech in the San Joaquin Valley.</h2>
                    <p>The technology industry is ever growing as tech becomes an important factor in the success of almost any business. Represent the forefront of technology in the Central Valley.</p>
                </div>
            </div>
            <div className='second-page-text-line'>
                <div className='second-page-text-box2'>
                    <h2>Grow your technology.</h2>
                    <p>Introduce your company to hundreds of students and test out new APIs, launch big ideas for our participants to build, and easily scout and interview new qualified recruits.</p>
                </div>
            </div>
            <div className='second-page-text-line'>
                <div className='second-page-text-box3'>
                    <h2>Build Connections with talented participants.</h2>
                    <p>Witness the budding talent cultivated at our event by young innovators from around the world. Network with our participants and build meaningful connections and relationships.</p>
                </div>
            </div>
        </section>
    )
};

export default SecondPage;